import AdviserProfilesSearchApi from '../../core/api/AdviserProfilesSearchApi'
const adviserProfilesSearchApi = new AdviserProfilesSearchApi()

export const SERVICE_SELECTED = 'SERVICE_SELECTED'
export const PREFERRED_LANGUAGE_SELECTED = 'PREFERRED_LANGUAGE_SELECTED'
export const INVESTOR_DESCRIPTION_SELECTED = 'SET_INVESTOR_DESCRIPTIONID'
export const KNOWS_HOW_MUCH_TO_INVEST_OPTION_SELECTED = 'KNOWS_HOW_MUCH_TO_INVEST_OPTION_SELECTED'
export const MONTHLY_INVESTMENT_AMOUNT_SELECTED = 'MONTHLY_INVESTMENT_AMOUNT_SELECTED'
export const ONCE_OFF_INVESTMENT_AMOUNT_SELECTED = 'ONCE_OFF_INVESTMENT_AMOUNT_SELECTED'
export const SEARCH_CRITERIA_CLEAR_ALL = 'SEARCH_CRITERIA_CLEAR_ALL'
export const SEARCH_CRITERIA_SET_USER_ADDRESS = 'SEARCH_CRITERIA_SET_USER_ADDRESS'
export const FETCHING_TOTAL_PROFILE_MATCHES = 'FETCHING_TOTAL_PROFILE_MATCHES'
export const FETCHED_TOTAL_PROFILE_MATCHES = 'FETCHED_TOTAL_PROFILE_MATCHES'
import { CLEAR_INVESTMENT_AMOUNT_CONTAINER,
  fetchKnowsHowMuchToInvestOptions
} from './InvestmentAmountContainer/investmentAmountContainerActions.js'
import { CLEAR_MARKER_ADDRESS } from './Location/LocationContainerActions'
import {events as searchEvents} from '../AdviserSearchResultsListContainer/adviserSearchResultsListContainerActions'
export const events = {
  fetch: {
    totalMatchingProfiles: fetchTotalMatchingProfiles
  }
}

export const actions = {
  set: {
    investorDescription: INVESTOR_DESCRIPTION_SELECTED,
    resultsRefreshed: 'REFRESHED_SEARCH_RESULTS'
  },
  fetching: {
    profileMatches: FETCHING_TOTAL_PROFILE_MATCHES
  },
  fetched: {
    profileMatches: FETCHED_TOTAL_PROFILE_MATCHES
  }
}

export const clearAllSearchCriteria = () => {
  let events = [
    SEARCH_CRITERIA_CLEAR_ALL,
    CLEAR_INVESTMENT_AMOUNT_CONTAINER,
    CLEAR_MARKER_ADDRESS,
    searchEvents.clear.results
  ]

  return (dispatch) => {
    events.forEach((event) => {
      dispatch({type: event})
    })
    dispatch(fetchKnowsHowMuchToInvestOptions())
  }
}

export const serviceSelected = financialServiceId => ({
  type: SERVICE_SELECTED,
  financialServiceId
})

export const investorDescriptionSelected = investorDescriptionId => ({
  type: INVESTOR_DESCRIPTION_SELECTED,
  investorDescriptionId
})

export const knowsHowMuchToInvestOptionSelected = knowsHowMuchToInvestOptionId => ({
  type: KNOWS_HOW_MUCH_TO_INVEST_OPTION_SELECTED,
  knowsHowMuchToInvestOptionId
})

export const monthlyInvestmentAmountSelected = monthlyInvestmentAmount => ({
  type: MONTHLY_INVESTMENT_AMOUNT_SELECTED,
  monthlyInvestmentAmount
})

export const onceOffInvestmentAmountSelected = onceOffInvestmentAmount => ({
  type: ONCE_OFF_INVESTMENT_AMOUNT_SELECTED,
  onceOffInvestmentAmount
})

export const preferredLanguageSelected = languageId => ({
  type: PREFERRED_LANGUAGE_SELECTED,
  languageId
})

export const setUserAddress = (userAddress) => (
  {
    type: SEARCH_CRITERIA_SET_USER_ADDRESS,
    userAddress
  }
)

const fetchingTotalProfileMatches = () => ({
  type: FETCHING_TOTAL_PROFILE_MATCHES
})

export function fetchTotalMatchingProfiles (searchCriteria) {
  const request = adviserProfilesSearchApi.getTotalMatches(searchCriteria)
  return async (dispatch) => {
    dispatch(fetchingTotalProfileMatches())
    try{
      const response = await request
      const data = await response.json()
      dispatch(adviserProfilesSearchApi.handleResponse(FETCHED_TOTAL_PROFILE_MATCHES, data))
    }catch(err){
      console.error('Error fetching total matches:', err)
    }
  }
}
